export const QK_HOUSEHOLD_UNIT_ACCESSIBILITY = 'householdUnitAccessibility';
